import { useState } from 'react';
import { Filters, TFilterForm } from './filters';
import { useTableHelper } from './helpers/useTableHelper';
import { useApiHelper } from './helpers/apiHelper';
import { SearchBox, Table } from '../../../components';
import './index.scss';
import dayjs from 'dayjs';
import { MatrixCards } from '../common/matrixCards';
import { SettlementReport } from './report';

const currDate = new Date();
export const Settlements: React.FC<{
  enterpriseId: number | undefined;
}> = ({ enterpriseId }) => {
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState<TFilterForm>({
    startDate: dayjs(currDate).subtract(7, 'days').toDate(),
    endDate: dayjs(currDate).toDate(),
  });
  const [searchString, setSearchString] = useState('');

  const {
    settlementsData,
    isLoading,
    formattedMatrixData,
  } = useApiHelper(
    pageNo,
    pageSize,
    filters,
    searchString,
    enterpriseId
  );

  const { columns } = useTableHelper(enterpriseId);

  return (
    <div>
      <div className="top-header mt-2">
        <div className="contents justify-between">
          <span className="disclaimer-text">
            {`Note: Data is correctly reflected from 21st
            Nov'22 onwards. Transactions made before this
            may have incomplete data in few instances.`}
          </span>
          {enterpriseId && (
            <SettlementReport enterpriseId={enterpriseId} />
          )}
        </div>
      </div>
      <div className="flex justify-between my-7">
        <div className="flex">
          <SearchBox
            className="mr-3"
            placeholder="Search by UTR No."
            searchValue={searchString}
            setSearchString={setSearchString}
          />
          <Filters
            filters={filters}
            setFilters={setFilters}
          />
        </div>
      </div>
      <MatrixCards matrixData={formattedMatrixData} />
      <Table
        columns={columns}
        data={settlementsData?.settlements}
        rowsPerPage={pageSize}
        rowKey={'settlementUtr'}
        setRowsPerPage={setPageSize}
        count={settlementsData?.totalElements}
        page={pageNo}
        setPage={setPageNo}
        isLoading={isLoading}
      />
    </div>
  );
};
